<template>
  <div class="menu-box" style="overflow:hidden">
    <!--顶部导航模式开始-->
    <!-- <div v-if="MENUCONFIG.STYLE.isTop" class="top-box spaceLeft">
      <a-layout>
        <a-layout-header
          :style="{
            'background-color': MENUCONFIG.STYLE.backgroundColor,
            color: MENUCONFIG.STYLE.color
          }"
          style="border-bottom: 1px solid #e8e8e8;"
        >
          <div class="spaceLeft" style="width:100%;">
            <div class="menu-logo">
              <img src="/static/images/logo.png" />
            </div>
            <div class="top-menu-main">
              <menu-tree
                ref="menuTree"
                :menuData="menuData"
                :activeIndex="activeIndex"
                :activeOpenIndex="activeOpenIndex"
                @handleSelect="handleSelect"
              ></menu-tree>
            </div>
            <a-dropdown class="user-box" placement="bottomRight">
              <span
                class="pointer"
                @click="e => e.preventDefault()"
                style="curnsor"
                >{{ userObj.userName || "用户名称" }} <a-icon type="down"
              /></span>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;">角色切换</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" @click="toSecurity">安全中心</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" @click="logout">退出登录</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </a-layout-header>
        <a-layout-content v-if="MENUCONFIG.STYLE.isTab">
          <a-tabs
            v-model="activeIndex"
            hide-add
            type="editable-card"
            @edit="removeOneTab"
            @change="handleTabSelect"
            @contextmenu.prevent="showTabOperFun($event)"
            size="small"
          >
            <a-tab-pane
              v-for="item in openedTabBar"
              :key="item.menuCode"
              :tab="item.menuName"
              :closable="item.closable"
            ></a-tab-pane>
          </a-tabs>
        </a-layout-content>
      </a-layout>
    </div> -->
    <!--顶部导航模式结束-->

    <!--左侧导航模式开始-->
    <div v-if="!MENUCONFIG.STYLE.isTop" class="left-box">
      <a-layout>
        <a-layout-header
          :style="{
            'background-color': MENUCONFIG.STYLE.backgroundColor,
            color: MENUCONFIG.STYLE.color
          }"
          style="border-bottom: 1px solid #e8e8e8;overflow:hidden;z-index:999;box-shadow: 0px 0px 6px 3px rgb(204 204 204 / 25%);"
        >
          <div class="spaceBetween header-main">
            <div class="spaceLeft">
              <div class="menu-logo spaceLeft">
                <img src="@/assets/images/nylogo.png" alt="" srcset="" height="40">
              </div>
              <!-- <a-button :icon="leftSideHide ? 'menu-unfold' : 'menu-fold'" @click="switchLeftSide" ></a-button> -->
              <div
                class="text-size-14 time-text"
                style="margin-left:15px;"
              >
                上次登录：{{
                  moment(getSessionData.lastLoginTime).format("YYYY-MM-DD HH:mm:ss")
                }}
              </div>
              <!-- <a-breadcrumb style="margin-left:30px;font-size:12px;">
								<a-breadcrumb-item v-for="item in breadCrumb" :key="item.menuCode">{{item.menuName}}</a-breadcrumb-item>
							</a-breadcrumb> -->
            </div>
            <div class="spaceLeft" style="min-width:240px">
            	<a-tooltip placement="bottom">
				        <template slot="title">
		          		帮助中心
				        </template>
				        <a-icon @click="toHelp" type="question-circle" style="color:#505766;font-size: 18px;margin-right:26px;cursor: pointer;"/>
				      </a-tooltip>
              <div style="margin-right:15px;">
                <a-badge
                  :count="$store.getters['home/getMessageCount'] && $store.getters['home/getMessageCount'].total"
                  :offset="[10, -2]"
                >
                  <a-icon type="bell" style="font-size:16px;" @click="toMessage"/>
                </a-badge>
              </div>
              <a-divider type="vertical" />
              <a-dropdown class="user-box" placement="bottomLeft" style="margin-left:20px;">
                <div class="pointer">
                  <svg class="icon" aria-hidden="true" style="font-size:16px;">
                    <use xlink:href="#gold-icon-yonghuming"></use>
                  </svg>
                  {{ userObj.userName ||  userObj.name || "用户名称" }} <a-icon type="down" />
                </div>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a @click="roleShowInit" href="javascript:;">角色切换</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="javascript:;" @click="toSecurity">安全中心</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a href="javascript:;" @click="logout">退出登录</a>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
          </div>
        </a-layout-header>
        <a-layout>
          <a-layout-sider
            v-model="leftSideHide"
            :trigger="null"
            collapsible
            :style="{ 'background-color': MENUCONFIG.STYLE.backgroundColor }"
          >
            <div class="left-scroll-box">
              <div style="width:200px;height:100%;">
                <menu-tree
                  ref="menuTree"
                  :menuData="menuData"
                  :activeIndex="activeIndex"
                  :activeOpenIndex="activeOpenIndex"
                  @handleSelect="handleSelect"
                ></menu-tree>
              </div>
            </div>
          </a-layout-sider>
          <a-layout-content v-if="MENUCONFIG.STYLE.isTab">
            <a-tabs
              v-model="activeIndex"
              hide-add
              type="editable-card"
              @edit="removeOneTab"
              @change="handleTabSelect"
              @contextmenu.prevent="showTabOperFun($event)"
              size="small"
            >
              <a-tab-pane
                v-for="item in openedTabBar"
                :key="item.menuCode"
                :tab="item.menuName"
                :closable="item.menuCode!='gongzuotai'"
              ></a-tab-pane>
            </a-tabs>
          </a-layout-content>
        </a-layout>
      </a-layout>
      <div class="bottom-btn" :class="{ small: leftSideHide }">
        <a-icon
          :type="leftSideHide ? 'menu-unfold' : 'menu-fold'"
          @click="switchLeftSide"
        />
      </div>
    </div>
    <!--左侧导航模式结束-->
    <dl id="contextMenu" v-show="showTabOper" style="left:220px;top:80px;">
      <dd>
        <a href="javascript:;" @click="removeOneTab(activeIndex, 'remove')"
          >关闭当前</a
        >
      </dd>
      <dd><a href="javascript:;" @click="removeOtherTab">关闭其他</a></dd>
      <dd><a href="javascript:;" @click="removeAllTab">全部关闭</a></dd>
      <dd><a href="javascript:;" @click="refreshCurTab">刷新当前</a></dd>
    </dl>

    <a-modal
      width="400px"
      title="角色切换"
      :visible="modalRoleShow"
      :maskClosable="false"
      @cancel="modalRoleShow = false"
      :destroyOnClose="true"
      :footer="null"
    >
      <div class="spaceCenter">
        <div
          v-for="item in roleList"
          :key="item.roleCode"
          @click="switchRole(item)"
          class="role-radio"
          :class="{
            'role-radio-active': roleActive(item),
            'role-radio-disabled': item.disabled
          }"
        >
          {{ item.roleName }}
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { logoutApi } from "@/api/login";
import { roleApi, getPermisson } from "@/api/role.js";
import menuTree from "@/components-frame/menu/menu-tree";
export default {
  name: "menu-bar",
  data() {
    return {
      activeIndex: "",
      activeOpenIndex: [],
      tabBarIndex: 0,
      leftSideHide: false,
      menuMap: {},
      pathMap: {},
      breadCrumb: [],
      showTabOper: false,
      modalRoleShow: false,
      roleList: []
    };
  },
  components: {
    menuTree
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj",
      menuData: "home/getMenuData",
      openedTabBar: "home/getOpenedTabBar",
      activeTabBar: "home/getActiveTabBar",
      getSessionData: "home/getSessionData"
    }),
    openedTabBarNames() {
      return this.openedTabBar.map(item => item.menuCode);
    }
  },
  created() {
    if (this.menuData.length) {
      this.initRender();
    }
  },
  methods: {
    ...mapMutations({
      setMenuData: "home/setMenuData",
      setSessionData: "home/setSessionData",
      setUserObj: "home/setUserObj",
      addOrGoTab: "home/addOrGoTab", // 打开/切换至tab
      setActiveTabBar: "home/setActiveTabBar", //设置当前激活的tab
      setOpenedTabBar: "home/setOpenedTabBar", //设置已打开的tab数组
      setPATHMAP: "home/setPATHMAP"
    }),
    toMessage(){
       this.MENUAPI.goToOneTab({
        path: "notice/transferNotice"
      });
    },
    initRender() {
      this.MENUCONFIG.PATHMAP = {};
      this.setMenuMap(this.menuData);
      this.openFirstMenu();
    },
    setMenuMap(subList, keyPath = [], itemPath = []) {
      //menu初始化，生成menuCode menuItem映射数据
      for (let i = 0; i < subList.length; i++) {
        if (subList[i].subnav) {
          this.setMenuMap(
            subList[i].subnav,
            [...keyPath, subList[i].menuCode],
            [...itemPath, this.utils.deepClone(subList[i])]
          );
        } else {
          subList[i].keyPath = [];
          subList[i].keyPath.push(...keyPath, subList[i].menuCode);
          subList[i].itemPath = [];
          subList[i].itemPath.push(
            ...itemPath,
            this.utils.deepClone(subList[i])
          );
          this.MENUCONFIG.PATHMAP[subList[i].path] = subList[i];
          this.menuMap[subList[i].menuCode] = subList[i];
        }
      }
      this.setPATHMAP(this.MENUCONFIG.PATHMAP);
    },
    openFirstMenu() {
      //打开初始化tab页面
      if (window.sessionStorage) {
        //取session
        this.setActiveTabBar(
          window.sessionStorage.getItem("ACTIVETABBAR") || ""
        );
        this.setOpenedTabBar(
          JSON.parse(window.sessionStorage.getItem("OPENEDTABBAR")) || []
        );
      }
      let tabItem = this.openedTabBar.find(i => i.menuCode == this.activeTabBar);
      if (!this.menuMap[this.activeTabBar] && !tabItem) {
        //如果menumap中不存在此menu，则取配置的default menu，如无默认配置则取第一个能打开的页面
        const firstSubMenu = this.getFirstSubMenu(this.menuData);
        const defaultCode = this.MENUCONFIG.DEAULTMENU.menuCode || "null";
        const firstCode = this.menuMap[defaultCode]
          ? defaultCode
          : firstSubMenu.menuCode;
        this.setActiveTabBar(firstCode);
        this.addOrGoTab(this.menuMap[firstCode]);
        this.activeOpenIndex = this.MENUCONFIG.STYLE.isTop
          ? []
          : firstSubMenu.keyPath;
      } else {
        this.activeOpenIndex = this.MENUCONFIG.STYLE.isTop
          ? []
          : (this.menuMap[this.activeTabBar] && this.menuMap[this.activeTabBar].keyPath || []);
      }
      this.activeIndex = this.activeTabBar;
      this.getBreadTitle();
      this.changeRoutePath(this.activeIndex, "init");
    },
    getFirstSubMenu(menuList) {
      let res = null;
      for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].subnav && menuList[i].subnav.length) {
          res = this.getFirstSubMenu(menuList[i].subnav);
          return res;
        } else {
          res = menuList[0];
          return res;
        }
      }
    },
    changeRoutePath(menuCode, init, routerWatch) {
      //切换路由
      let menuItem = null;
      menuItem = this.menuMap[menuCode || this.activeTabBar];
      let item = this.openedTabBar.find(i => i.menuCode == (menuCode || this.activeTabBar));
      if(item){
        menuItem = item;;
      }
      if (!menuItem) {
        menuItem = {
          menuName:this.$route.meta.title,
          menuCode:this.$route.name,
          path:this.$route.fullPath
        }
      }

      if(!routerWatch){
        let activePath =
          window.sessionStorage && window.sessionStorage.getItem("ACTIVEPATH");
        if (activePath && init) return;
        let isNeedPre = menuItem.path.substring(0,1) != "/";
        let path = isNeedPre ? "/" + menuItem.path : menuItem.path;
        if (this.$route.path != path) {
          this.$router.push({
            path: path
          });
        }
      }
      else{
        this.addOrGoTab(menuItem);
      }

    },
    handleSelect({ item, key, keyPath }) {
      //菜单点击回调
      const menuObj = this.menuMap[key] || {};
      this.addOrGoTab(menuObj);
      this.changeRoutePath(menuObj.menuCode);
    },
    handleTabSelect(menuCode) {
      //切换tab回调
      this.setActiveTabBar(menuCode);
      this.changeRoutePath(this.activeIndex);
    },
    removeOneTab(menuCode, action) {
      if (action != "remove") return;
      let tabs = this.openedTabBar;
      if (tabs.length == 1) {
        alert("再关就没有了哦");
        return;
      }

      let activeTabBar = this.activeTabBar;
      if (activeTabBar === menuCode) {
        tabs.forEach((tab, index) => {
          if (tab.menuCode === menuCode) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeTabBar = nextTab.menuCode;
              this.activeIndex = nextTab.menuCode;
            }
          }
        });
      }
      this.setActiveTabBar(activeTabBar);
      this.setOpenedTabBar(tabs.filter(tab => tab.menuCode !== menuCode));
      this.changeRoutePath(this.activeIndex);
    },
    removeAllTab() {
      this.showTabOper = false;
      this.setActiveTabBar(this.openedTabBar[0].menuCode);
      this.setOpenedTabBar(this.openedTabBar.slice(0, 1));
      this.changeRoutePath(this.activeIndex);
    },
    removeOtherTab() {
      this.showTabOper = false;
      this.setOpenedTabBar(
        this.openedTabBar.filter(
          (tab, index) => tab.menuCode == this.activeTabBar || index == 0
        )
      );
    },
    refreshCurTab() {
      this.MENUAPI.reloadRouter();
    },
    switchLeftSide() {
      this.leftSideHide = !this.leftSideHide;
      this.$emit("switchLeftSide", this.leftSideHide);
    },
    showTabOperFun(ev) {
      //右键展示tab操作
      ev = ev || window.event;

      let scrollX =
        document.documentElement.scrollLeft || document.body.scrollLeft;
      let scrollY =
        document.documentElement.scrollTop || document.body.scrollTop;
      let pageX = ev.pageX || ev.clientX + scrollX;
      let pageY = ev.pageY || ev.clientY + scrollY;

      let maxX = document.body.offsetWidth - 96;
      if (this.leftSideHide) {
        if (pageX > maxX) {
          pageX = maxX;
        }
        document.getElementById("contextMenu").style.left = pageX - 170 + "px";
      } else {
        if (pageX > maxX) {
          pageX = maxX;
        }
        document.getElementById("contextMenu").style.left = pageX - 10 + "px";
      }
      document.getElementById("contextMenu").style.top = pageY + 10 + "px";
      this.showTabOper = true;
    },
    logout() {
      logoutApi()
        .then(res => {
          this.$router.push({ path: "/login" });
          this.setTabBarInSession("clear");
          this.setUserObj({});
          this.setSessionData({});
        })
        .catch(err => {
          console.log(err);
        });
    },
    setTabBarInSession(type) {
      //将已开tab存入session，刷新页面时保留
      if (window.sessionStorage) {
        if (type == "clear") {
          window.sessionStorage.removeItem("ACTIVEPATH");
          window.sessionStorage.removeItem("ACTIVETABBAR");
          window.sessionStorage.removeItem("OPENEDTABBAR");
          window.localStorage.removeItem("CURRENTROLE");
        } else {
          window.sessionStorage.setItem("ACTIVETABBAR", this.activeTabBar);
          window.sessionStorage.setItem(
            "OPENEDTABBAR",
            JSON.stringify(this.openedTabBar)
          );
        }
      }
    },
    getBreadTitle() {
      let item = this.menuMap[this.activeIndex] || {};
      this.breadCrumb = item.itemPath || [];
    },
    dropdownCon(triggerNode) {
      //解决 antui下拉列表影响页面滚动
      return triggerNode.parentNode || document.body;
    },
    roleShowInit() {
      //切换角色相关方法
      getPermisson()
        .then(res => {
          let roles = res.data.map(i => i.roleCode);
          localStorage.setItem("AVAILABLEROLE", JSON.stringify(roles));
          this.roleShow();
        })
        .catch(err => {
          console.log(err);
        });
    },
    roleShow() {
      roleApi(null, true)
        .then(res => {
          this.roleList = res.data.concat([
            { roleName: "全部", roleCode: "all" }
          ]);
          let avalibelRoles =
            (localStorage.getItem("AVAILABLEROLE") &&
              JSON.parse(localStorage.getItem("AVAILABLEROLE"))) ||
            [];
          let count = 0;
          this.roleList.forEach((i, index) => {
            this.$set(this.roleList[index], "disabled", true);
            if (i.roleCode != "all") {
              if (avalibelRoles.indexOf(i.roleCode) > -1) {
                count++;
                this.$set(this.roleList[index], "disabled", false);
              }
            }
          });
          if (count == res.data.length) {
            this.roleList[this.roleList.length - 1].disabled = false;
          }
          this.modalRoleShow = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    switchRole(item) {
      if (item.disabled) return;
      let curRole = [];
      if (item.roleCode == "all") {
        this.roleList.forEach(i => {
          if (i.roleCode != "all") {
            curRole.push(i.roleCode);
          }
        });
      } else {
        curRole = [item.roleCode];
      }
      this.setTabBarInSession("clear");
      /* 设置CURRENTROLE 用以标记当前选择的ROLE */
      localStorage.setItem("CURRENTROLE", JSON.stringify(curRole));
      location.assign("");
    },
    roleActive(item) {
      let res = false;
      if (window.localStorage) {
        const hasRoles = JSON.parse(window.localStorage.getItem("CURRENTROLE"));
        const index = hasRoles.indexOf(item.roleCode);
        if (index > -1 && hasRoles.length == 1) {
          res = true;
        } else if (
          hasRoles.length == this.roleList.length - 1 &&
          item.roleCode == "all"
        ) {
          res = true;
        } else {
          res = false;
        }
      }
      return res;
    },
    toSecurity() {
      this.MENUAPI.goToOneTab({
        path: "security/main"
      });
    },
    toHelp(){
      window.open(process.env.VUE_APP_WIKI_URL)
    }
  },
  watch: {
    openedTabBar: {
      handler(newName, oldName) {
        this.setTabBarInSession();
      },
      deep: true
    },
    activeTabBar(newVal) {
      this.activeIndex = newVal;
      this.getBreadTitle();
      this.setTabBarInSession();
    },
    $route(newVal){
      if(newVal.meta){
        if(newVal.meta.notMenu){
          this.changeRoutePath(this.$route.name, null, "routerWatch");
        }
        if(newVal.meta && newVal.meta.keepAlive){
          this.$store.commit("home/setCachedViews",newVal.name);
        }
      }

    }
  }
};
</script>

<style scoped="scoped" lang="less">
@import "~@/css/variable.less";

.top-box {
  height: 95px;
}
.menu-logo {
  margin: 0 16px 0 10px;
  font-size: 16px;
}
.top-menu-main {
  flex: 1;
}
.left-menu-main {
  width: 200px;
}
.left-box .ant-layout-sider {
  height: calc(100vh - 64px);
  overflow: hidden;
}
.left-box /deep/ .ant-menu-inline {
  border-right: none;
}
.left-scroll-box {
  width: 220px;
  height: calc(100vh - 64px);
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  .ant-menu {
    min-height: 100%;
    background: @menuBackground;
    color: @menuColor !important;
  }
  .ant-menu:hover {
    color: @menuColor !important;
  }
  .ant-menu:not(.ant-menu-horizontal) /deep/ .ant-menu-item-selected {
    background-color: @menuActiveBackground !important;
    color: @menuActiveColor !important;
  }
}
.left-scroll-box .ant-menu-inline-collapsed {
  width: 80px !important;
}
/deep/ .ant-menu-horizontal {
  border-bottom: none;
}
/deep/ .ant-layout-header {
  padding: 0;
}
/deep/ .ant-layout-content {
  background-color: #fff;
}
/deep/ .ant-tabs-tab,
/deep/ .ant-tabs-tab-active,
/deep/ .ant-tabs-nav-container {
  height: 30px !important;
  line-height: 30px !important;
}
.user-box {
  width: 130px;
  // float: right;
  position: absolute;
  right: 0;
  z-index: 999;
  top:0;
}
#contextMenu {
  position: absolute;
  z-index: 10;
  width: 100px;
  border: 1px solid #ddd;
  box-shadow: 0px 0px 3px 1px #f5f5f5;
  border-radius: 3px;
  top: 80px;
  background: #fff;
}
#contextMenu a {
  color: #666;
}
#contextMenu dd {
  line-height: 30px;
  margin-bottom: 0;
  cursor: pointer;
  text-align: center;
}
#contextMenu dd:hover {
  background: #f5f5f5;
}
.role-radio:first-child {
  border-radius: 4px 0 0 4px;
  border-left: 1px solid #d9d9d9;
}
.role-radio:last-child {
  border-radius: 0 4px 4px 0;
}
.role-radio {
  padding: 0 15px;
  height: 32px;
  line-height: 30px;
  border: 1px solid #d9d9d9;
  border-left: none;
  cursor: pointer;
  margin-bottom: 30px;
}
.role-radio-active {
  border: 1px solid #1890ff;
  border-left: 1px solid #1890ff !important;
  color: #1890ff;
}
.role-radio:hover {
  color: #1890ff;
}
.role-radio-disabled {
  cursor: no-drop;
  background: #eee;
}

.menu-box {
  /deep/ .ant-layout-header {
    height: 58px;
    padding: 0;
    line-height: 58px;
  }
  /deep/ .ant-menu-vertical .ant-menu-item::after,
  /deep/ .ant-menu-vertical-left .ant-menu-item::after,
  /deep/ .ant-menu-vertical-right .ant-menu-item::after,
  /deep/ .ant-menu-inline .ant-menu-item::after {
    left: 0 !important;
    right: auto !important;
    border-right: 3px solid @menuActiveLineColor;
  }
  .menu-name {
    color: #fff;
  }
  /deep/ .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: #127df3;
    .menu-name {
      color: #fff;
    }
  }
  /deep/ .ant-menu-item-active,
  /deep/ .ant-menu-submenu-active,
  /deep/ .ant-menu-submenu-selected {
    color: @menuActiveColor !important;
  }
  /deep/ .ant-menu-item:hover,
  /deep/ .ant-menu:not(.ant-menu-inine) .ant-menu-submenu-open,
  /deep/ .ant-menu-submenu-title:hover {
    color: @menuActiveColor !important;
  }
  /deep/ .ant-menu-item-active .ant-menu-submenu-arrow {
    color: @menuActiveColor !important;
  }
  /deep/ .ant-menu-item:not(.ant-menu-item-selected) {
    background: none;
  }
  /deep/ .ant-layout-sider {
    flex: 0 0 210px !important;
    max-width: 210px !important;
    min-width: 210px !important;
    width: 210px !important;
  }
  /deep/ .ant-menu-submenu-title .menu-name {
    font-weight: bold;
  }
  /deep/ .ant-menu-sub {
    background-color: @menuSubBackground;
    color: @menuSubColor !important;
  }
  /deep/ .ant-menu-vertical .ant-menu-item:not(:last-child),
  /deep/ .ant-menu-vertical-left .ant-menu-item:not(:last-child),
  /deep/ .ant-menu-vertical-right .ant-menu-item:not(:last-child),
  /deep/ .ant-menu-inline .ant-menu-item:not(:last-child) {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  /deep/ .ant-menu-vertical .ant-menu-item,
  /deep/ .ant-menu-vertical-left .ant-menu-item,
  /deep/ .ant-menu-vertical-right .ant-menu-item,
  /deep/ .ant-menu-inline .ant-menu-item,
  /deep/ .ant-menu-vertical .ant-menu-submenu-title,
  /deep/ .ant-menu-vertical-left .ant-menu-submenu-title,
  /deep/ .ant-menu-vertical-right .ant-menu-submenu-title,
  /deep/ .ant-menu-inline .ant-menu-submenu-title {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  /deep/ .ant-menu-submenu-title {
    line-height: 48px;
    min-height: 48px;
  }
  /deep/ .ant-menu-inline.ant-menu-submenu {
    line-height: 48px;
    min-height: 48px;
  }
  .left-menu-div {
    width: 210px;
    height: 100%;
  }

  /deep/
    .ant-menu-submenu-inline
    > .ant-menu-submenu-title
    .ant-menu-submenu-arrow::before,
  /deep/
    .ant-menu-submenu-inline
    > .ant-menu-submenu-title
    .ant-menu-submenu-arrow::after {
    color: @menuColor !important;
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      from(@menuColor),
      to(@menuColor)
    ) !important;
    background-image: linear-gradient(
      to right,
      @menuColor,
      @menuColor
    ) !important;
  }
  /deep/
    .ant-menu-submenu-selected
    > .ant-menu-submenu-title
    .ant-menu-submenu-arrow::before,
  /deep/
    .ant-menu-submenu-selected
    > .ant-menu-submenu-title
    .ant-menu-submenu-arrow::after,
  /deep/
    .ant-menu-submenu-open
    > .ant-menu-submenu-title
    .ant-menu-submenu-arrow::before,
  /deep/
    .ant-menu-submenu-open
    > .ant-menu-submenu-title
    .ant-menu-submenu-arrow::after {
    color: @menuActiveColor !important;
    background-image: -webkit-gradient(
      linear,
      left top,
      right top,
      from(@menuActiveColor),
      to(@menuActiveColor)
    ) !important;
    background-image: linear-gradient(
      to right,
      @menuActiveColor,
      @menuActiveColor
    ) !important;
  }
  .bottom-btn {
    position: absolute;
    bottom: -6px;
    left: 0;
    background: @menuBottomBackground;
    height: 40px;
    line-height: 40px;
    text-align: right;
    width: 200px;
    padding-right: 5px;
    color: #fff;
    transition: width 0.26s ease;
  }
  .bottom-btn.small {
    width: 79px;
  }
}

.header-main{
  width: 100%;
  flex:1;
  background: @headerBackground;
  color:@headerColor;
  .time-text{
    color:@headerTimeColor;
  }
}
.menu-logo {
  .logo-text{
    width: 130px;
    display: inline-block;
  }
  .logo-right{
    border-left:1px solid #d1dff0;
    margin-left:12px;
    padding-left:12px;
    color:#065abc;
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
    .logo-right-sm{
      font-size: 12px;
      font-weight: lighter;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components-frame/menu/menu-bar.vue